import { render, staticRenderFns } from "./CampanhaAccordion.vue?vue&type=template&id=9e639a4e&scoped=true"
import script from "./CampanhaAccordion.vue?vue&type=script&lang=js"
export * from "./CampanhaAccordion.vue?vue&type=script&lang=js"
import style0 from "./CampanhaAccordion.vue?vue&type=style&index=0&id=9e639a4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e639a4e",
  null
  
)

export default component.exports